import stringFormat from 'string-format'
import projectGameImageSelector from 'root/src/client/logic/project/selectors/projectGameImageSelector'
import memoizeWith from 'ramda/src/memoizeWith'
import head from 'ramda/src/head'
import propOr from 'ramda/src/propOr'
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'

const responseLenses = getResponseLenses(GET_PROJECT)
const { pathOrGames } = responseLenses

export default memoizeWith(
	(state, props) => JSON.stringify(getRecordSelector(state, props)),
	(state, props) => {
		const games = head(pathOrGames([], getRecordSelector(state, props)))
		const squareImg = propOr(undefined, 'desktop', games)
		if (squareImg) {
			return squareImg
		}

		return stringFormat(
			projectGameImageSelector(state, props),
			{ width: 500, height: 500 },
		)
	},
)
